module.exports = "https://cdn.realtymogul.com/static/media/Griffin_Q.024095f0.jpg";